export default function HomeIcon({ className = "", onClick = null }) {
  return (
    <>
      <svg
        className={className}
        onClick={onClick}
        id="Capa_1"
        data-name="Capa 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 700 700"
      >
        <path
          d="M135.78,528.24h21.89l-.15-99.54c0-2.7,2.1-4.8,4.8-4.95,18.59-.45,85.9-.15,108.68.15,1.95,0,2.7,2.7,1.05,3.75-18.59,11.99-58.91,50.52-16.04,100.59h177.79c12.74-11.09,19.19-26.68,19.19-46.17,0-35.68-21.59-55.92-76.9-71.21-56.07-15.29-110.63-30.58-147.21-49.17-6.9-3.45-77.2-33.88-76.75-135.82.15-19.04,2.1-37.18,6.45-53.82h-22.79c-3.15,0-5.55-2.55-5.55-5.55v-59.96c0-3,2.55-5.55,5.55-5.55h428.44c3,0,5.55,2.55,5.55,5.55v59.81c0,3.15-2.55,5.55-5.55,5.55h-21.89l.15,99.54c0,2.7-2.1,4.8-4.8,4.95-18.59.45-86.05.15-108.68-.15-1.95,0-2.7-2.7-1.05-3.75,18.74-12.14,58.76-50.52,16.19-100.59h-177.94c-12.74,11.09-19.19,26.68-19.19,46.17,0,35.68,21.59,55.92,76.9,71.21,56.07,15.29,110.63,30.58,147.21,49.17,6.9,3.45,80.2,38.98,76.75,135.82-.75,19.04-2.1,37.18-6.45,53.82h22.79c3,0,5.55,2.55,5.55,5.55v59.81c0,3-2.55,5.55-5.55,5.55H135.78c-3.15,0-5.55-2.55-5.55-5.55v-59.81c0-3,2.4-5.4,5.55-5.4h0Z"
          style={{ strokeWidth: "0px" }}
        />
      </svg>
    </>
  );
}
